module.exports = __webpack_public_path__ + "img/fm.f3186e7f.jpg";